import { useState } from 'react'
import { Stack, Typography } from '@mui/material'
import Pressable from '@/theme/Pressable'
import styles from './thoughtchain/thoughtchain.module.scss'

const LIMIT = 180

export default function NarrationText({ text, meta, error = false }) {
  const [expanded, setExpanded] = useState(false)
  const collapsible = text.length > LIMIT
  const visible = collapsible && !expanded
    ? `${text.slice(0, LIMIT).trimEnd()}…`
    : text
  return (
    <Stack sx={{ gap: 0.2 }}>
      <Typography
        component="p"
        className={`${styles.narrationBody} ${error ? styles.narrationBodyError : ''}`}
      >
        {visible}
      </Typography>
      {collapsible ? (
        <Pressable
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
          sx={{
            alignSelf: 'flex-start',
            fontSize: 'var(--app-thought-font-size)',
            color: 'var(--app-text-secondary)',
            textDecoration: 'underline',
          }}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Pressable>
      ) : null}
      {meta ? (
        <Typography sx={{ fontSize: 'var(--app-font-size-caption-1)', color: 'var(--app-text-tertiary)' }}>
          {meta}
        </Typography>
      ) : null}
    </Stack>
  )
}
